import Datetime from 'react-datetime'
import moment from 'moment'
import type { InstallationCraneAppointment, InstallationCraneScheduleState } from '../../types'
import { wonFormCheckInput, wonFormCheckLabel, wonFormCheckRow } from '../../formCheckClasses'

interface Props {
  isView: boolean
  craneSchedule: InstallationCraneScheduleState
  updateCraneSchedule: (patch: Partial<InstallationCraneScheduleState>) => void
}

const APPOINTMENT_ROWS: {
  key: 'mainPile' | 'auspiciousPile' | 'actualPile'
  label: string
}[] = [
  { key: 'mainPile', label: 'นัดตอกเสาเอกวันที่' },
  { key: 'auspiciousPile', label: 'นัดตอกเสาฤกษ์วันที่' },
  { key: 'actualPile', label: 'นัดตอกเสาจริงวันที่' },
]

const InstallationCraneSection: React.FC<Props> = ({
  isView,
  craneSchedule,
  updateCraneSchedule,
}) => {
  const updateAppointment = (
    key: 'mainPile' | 'auspiciousPile' | 'actualPile',
    patch: Partial<InstallationCraneAppointment>
  ) => {
    updateCraneSchedule({
      [key]: { ...craneSchedule[key], ...patch },
    })
  }

  const toggleAppointment = (key: 'mainPile' | 'auspiciousPile' | 'actualPile', enabled: boolean) => {
    updateAppointment(key, { enabled })
  }

  return (
    <div className='col-12'>
      <div className='card'>
        <div className='card-header'>
          <div className='card-title fw-bold'>งานด้านปั้นจั่น</div>
        </div>
        <div className='card-body'>
          <div className='d-flex flex-column gap-4'>
            {APPOINTMENT_ROWS.map(({ key, label }) => (
              <div key={key} className='d-flex flex-wrap align-items-center gap-3'>
                <div className={wonFormCheckRow}>
                  <input
                    className={wonFormCheckInput}
                    type='checkbox'
                    id={`won-install-crane-${key}`}
                    checked={craneSchedule[key].enabled}
                    disabled={isView}
                    onChange={e => toggleAppointment(key, e.target.checked)}
                  />
                  <label
                    className={`${wonFormCheckLabel} fw-semibold`}
                    htmlFor={`won-install-crane-${key}`}>
                    {label}
                  </label>
                </div>
                <Datetime
                  locale='en'
                  dateFormat='DD/MM/YYYY'
                  timeFormat='HH:mm'
                  value={craneSchedule[key].datetime ?? undefined}
                  onChange={(val: any) => {
                    if (moment.isMoment(val) || val instanceof Date) {
                      updateAppointment(key, { datetime: moment(val).toDate() })
                    }
                  }}
                  renderInput={props => (
                    <input
                      {...props}
                      autoComplete='off'
                      className='form-control form-control-sm'
                      style={{ maxWidth: 200 }}
                      disabled={isView || !craneSchedule[key].enabled}
                    />
                  )}
                  closeOnClickOutside
                />
              </div>
            ))}

            <div className='d-flex flex-wrap align-items-center gap-3'>
              <span className='text-gray-800 fw-semibold min-w-175px'>เสร็จงานวันที่</span>
              <Datetime
                locale='en'
                dateFormat='DD/MM/YYYY'
                timeFormat={false}
                value={craneSchedule.finishDate ?? undefined}
                onChange={(val: any) => {
                  if (moment.isMoment(val) || val instanceof Date) {
                    updateCraneSchedule({ finishDate: moment(val).toDate() })
                  }
                }}
                renderInput={props => (
                  <input
                    {...props}
                    autoComplete='off'
                    className='form-control form-control-sm'
                    style={{ maxWidth: 140 }}
                    disabled={isView}
                  />
                )}
                closeOnClickOutside
              />
            </div>

            <div className='d-flex flex-wrap align-items-center gap-3'>
              <span className='text-gray-800 fw-semibold'>รวมวันทำงาน</span>
              <input
                type='text'
                inputMode='numeric'
                className='form-control form-control-sm'
                style={{ maxWidth: 88 }}
                value={craneSchedule.totalWorkDays}
                disabled={isView}
                onChange={e => updateCraneSchedule({ totalWorkDays: e.target.value })}
              />
              <span className='text-gray-700'>วัน</span>
            </div>

            <div className='d-flex flex-wrap align-items-center gap-3'>
              <span className='text-gray-800 fw-semibold'>ค่าปรับวันละ</span>
              <input
                type='text'
                inputMode='decimal'
                className='form-control form-control-sm'
                style={{ maxWidth: 120 }}
                value={craneSchedule.penaltyPerDay}
                disabled={isView}
                onChange={e => updateCraneSchedule({ penaltyPerDay: e.target.value })}
              />
              <span className='text-gray-700'>บาท</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InstallationCraneSection
